// Charge la base commune
// Styles custom
import './scss/pages/contact'

// Scripts librairies
/* global Waypoint */
import 'waypoints/lib/jquery.waypoints.min.js'

// Pages
import { contactPage } from './js/pages/contact.page.js'
import { dtectMap } from './js/libs/utils'

require('./common.js')

// rafraîchissement
function r () {
  Waypoint.refreshAll()
}

// OwlCarousel
function getOwlCarousel () {
  import('./js/components/owl-carousel.js').then(() => {
    r()
  })
}

// Contact Form
function getContactForm () {
  const $f = $('form[name="contact_form"]')
  $f.find('button, input, textarea, select').prop('disabled', true).css({ opacity: 0.5 })
  import('./js/components/contact-form.js').then(() => {
    $f.find('button, input, textarea, select').prop('disabled', false).css({ opacity: 1 })
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion des carousel
  const $f = $('div.owl-carousel')
  if ($f.length) {
    $f.waypoint(function () {
      getOwlCarousel()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire de contact
  const $g = $('form.contact-form')
  if ($g.length) {
    $g.waypoint(function () {
      getContactForm()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // à exécuter une fois la GMap API correctement chargée
  dtectMap(function () {
    contactPage.init()
  })

  if ($('#go').length) {
    const t = $('#go')
    $('html, body').animate({
      scrollTop: ($(t).offset().top - $('#pageTop').height() - 50)
    }, 500)
  }
})
